import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#E6BFB8',
        accent: '#BB6B77',
        secondary: '#8F7A76',
        info: '#e75480',
        error: '#FF033e',
        success: '#4CAF50',
        warning: '#FFC107'
      },
    },
  }
})

export default vuetify